document.addEventListener("DOMContentLoaded", () => {
  const MAX_ATTEMPTS = 200;
  const INTERVAL_TIME = 100;

  // Shopify Video Player Config
  const videoPlayers = document.querySelectorAll(
    ".js-video-player-remove-image"
  );

  if (videoPlayers.length > 0) {
    videoPlayers.forEach((videoPlayer) => {
      if (videoPlayer.hasAttribute("aria-label")) {
        videoPlayer.removeAttribute("aria-label");
      }

      videoPlayer.setAttribute("title", "Embedded Video Player");

      const img = videoPlayer.querySelector("img");
      if (img) {
        img.setAttribute("loading", "lazy");
        img.setAttribute("alt", "");
        img.setAttribute("aria-hidden", "true");
        img.setAttribute("role", "presentation");
      }
    });
  }

  // Gorgias Chat
  // let chatButtonUpdated = false;
  // let innerContainersUpdated = false;
  // let gorgiasAttempts = 0;

  // const intervalId = setInterval(() => {
  //   if (gorgiasAttempts++ >= MAX_ATTEMPTS) {
  //     clearInterval(intervalId);
  //     return;
  //   }

  //   const gorgiasChatContainer = document.getElementById(
  //     "gorgias-chat-container"
  //   );

  //   if (!gorgiasChatContainer) return;

  //   if (!innerContainersUpdated) {
  //     gorgiasChatContainer.setAttribute("aria-hidden", "true");
  //     innerContainersUpdated = true;
  //   }

  //   const chatButton = gorgiasChatContainer.querySelector("#chat-button");
  //   if (chatButton && !chatButtonUpdated) {
  //     chatButton.removeAttribute("role");
  //     chatButtonUpdated = true;
  //   }

  //   if (chatButtonUpdated && innerContainersUpdated) {
  //     clearInterval(intervalId);
  //   }
  // }, INTERVAL_TIME);

  // Klaviyo Email Marketing
  let klaviyoAttempts = 0;
  const popupIntervalId = setInterval(() => {
    if (klaviyoAttempts++ >= MAX_ATTEMPTS) {
      clearInterval(popupIntervalId);
      return;
    }

    const klaviyoPopup = document.querySelector(".kl-teaser-XHV8vb");

    if (klaviyoPopup) {
      klaviyoPopup.setAttribute("aria-hidden", "true");
      clearInterval(popupIntervalId);
    }
  }, INTERVAL_TIME);

  // Remove attributes from elements
  const removeAttributes = (selector, attributes, root = document, checkEmpty = false) => {
    let attempts = 0;
    const interval = setInterval(() => {
      if (attempts++ >= MAX_ATTEMPTS) {
        clearInterval(interval);
        return;
      }

      const elems = root.querySelectorAll(selector);
      if (elems.length === 0) return;

      let updated = false;

      elems.forEach((elem) => {
        const isTextEmpty = elem.textContent.trim().length === 0;

        if ((checkEmpty && isTextEmpty) || !checkEmpty) {
          attributes.forEach((attribute) => {

            if (elem.hasAttribute(attribute)) {
              elem.removeAttribute(attribute);
              updated = true;
            }
          });
        }
      });

      if (updated) clearInterval(interval);
    }, INTERVAL_TIME);
  };

  removeAttributes(".yotpo-review-title", ["role", "aria-level"], document, true);
  removeAttributes(".yotpo-reviews-pagination-item", ["href"]);
  removeAttributes(".eko-gallery", ["aria-controls"]);
  removeAttributes("a.rebuy-product-title, a.rebuy-cart__flyout-item-product-title", ["role", "aria-level"], document);

  const handleGiftNoteShadowRoot = () => {
    let attempts = 0;
    const interval = setInterval(() => {
      if (attempts++ >= MAX_ATTEMPTS) {
        clearInterval(interval);
        return;
      }

      const giftNoteCore = document.querySelector("giftnote-core");
      if (giftNoteCore?.shadowRoot) {
        removeAttributes("button.iti__selected-country", ["aria-controls"], giftNoteCore.shadowRoot);
        removeAttributes("#iti-0__dropdown-content .iti__search-input", ["aria-controls"], giftNoteCore.shadowRoot);
        removeAttributes("#method, #method li, #method button", ["role"], giftNoteCore.shadowRoot);
        clearInterval(interval);
      }
    }, INTERVAL_TIME);
  };
  handleGiftNoteShadowRoot();

  // Add attributes to elements
  const addAttributes = (selector, attributes, root = document) => {
    let attempts = 0;
    const interval = setInterval(() => {
      if (attempts++ >= MAX_ATTEMPTS) {
        clearInterval(interval);
        return;
      }

      const elems = root.querySelectorAll(selector);

      if (elems.length === 0) return;

      let updated = false;

      elems.forEach((elem) => {
        for (const [attr, value] of Object.entries(attributes)) {
          if (!elem.hasAttribute(attr)) {
            elem.setAttribute(attr, value);
            updated = true;
          }
        }
      });

      if (updated) clearInterval(interval);
    }, INTERVAL_TIME);
  };

  addAttributes(".eko-smart-gallery-container iframe", {
    "title": "Product Image Gallery",
    "aria-hidden": "true",
    "tabindex": "-1",
    "role": "presentation"
  });

  addAttributes(".eko-gallery", {"aria-hidden": "true"});
  addAttributes("giftnote-core", { "aria-hidden": "true" });
  addAttributes("#li_sync_frame", {"title": "Sync Container"});
  addAttributes(".smcx-branding", {"aria-label": "Survey Monkey"});

  const handleShopCartSyncShadowRoot = () => {
    let attempts = 0;
    const interval = setInterval(() => {
      if (attempts++ >= MAX_ATTEMPTS) {
        clearInterval(interval);
        return;
      }

      const shopCartSync = document.querySelector("shop-cart-sync");
      if (shopCartSync?.shadowRoot) {
        const iframe = shopCartSync.shadowRoot.querySelector("iframe");
        if (iframe) {
          iframe.setAttribute("title", "Shop Analytics");
          clearInterval(interval);
        }
      }
    }, INTERVAL_TIME);
  };
  handleShopCartSyncShadowRoot();

  addAttributes(
    ".yotpo-star-rating-icon, .yotpo-verified-icon, .yotpo-reviews-pagination-item svg",
    {
      "aria-hidden": "true",
      role: "presentation",
      focusable: "false",
    }
  );

  const handlePaymentTermsShadowRoot = () => {
    let attempts = 0;
    const interval = setInterval(() => {
      if (attempts++ >= MAX_ATTEMPTS) {
        clearInterval(interval);
        return;
      }

      const shopifyPaymentTerms = document.querySelector("shopify-payment-terms");
      if (shopifyPaymentTerms?.shadowRoot) {
        addAttributes("#shopify-installments-content svg",
          {
            "aria-hidden": "true",
            role: "presentation",
            focusable: "false"
          }, shopifyPaymentTerms.shadowRoot);
        clearInterval(interval);
      }
    }, INTERVAL_TIME);
  };
  handlePaymentTermsShadowRoot();

  // Set attributes on elements
  const setAttributes = (selector, attributes, root = document, checkEmpty = false) => {
    let attempts = 0;
    const interval = setInterval(() => {
      if (attempts++ >= MAX_ATTEMPTS) {
        clearInterval(interval);
        return;
      }

      const elems = root.querySelectorAll(selector);
      if (elems.length === 0) return;

      let updated = false;

      elems.forEach((elem) => {
        const isTextEmpty = elem.textContent.trim().length === 0;

        if ((checkEmpty && isTextEmpty) || !checkEmpty) {
          for (const [attribute, value] of Object.entries(attributes)) {
            if (elem.getAttribute(attribute) !== value) {
              elem.setAttribute(attribute, value);
              updated = true;
            }
          }
        }
      });

      if (updated) clearInterval(interval);
    }, INTERVAL_TIME);
  };

  setAttributes('.rebuy-product-grid .rebuy-product-image img', { 'loading': 'lazy', 'alt': '', 'aria-hidden': 'true' });

  const setRebuyImageAriaLabel = () => {
    const updateAriaLabels = () => {
      const imageWrappers = document.querySelectorAll(
        ".rebuy-product-grid .rebuy-product-image"
      );
      if (imageWrappers.length === 0) return false;

      let updated = false;

      imageWrappers.forEach((imageWrapper) => {
        imageWrapper.querySelectorAll("img").forEach((img) => {
          img.setAttribute("alt", "");
        });

        const mediaParent = imageWrapper.closest(".rebuy-product-block");
        if (!mediaParent) return;

        const infoSibling = mediaParent.querySelector(".rebuy-product-info a");
        if (!infoSibling) return;

        const label = infoSibling.getAttribute("aria-label");
        if (label && imageWrapper.getAttribute("aria-label") !== label) {
          imageWrapper.setAttribute("aria-label", label);
          updated = true;
        }
      });

      return updated;
    };

    let attempts = 0;

    const interval = setInterval(() => {
      if (attempts++ >= MAX_ATTEMPTS) {
        clearInterval(interval);
        return;
      }

      const grid = document.querySelector(".rebuy-product-grid");

      if (!grid) return;

      updateAriaLabels();

      const observer = new MutationObserver(updateAriaLabels);
      observer.observe(grid, {
        childList: true,
        subtree: true,
      });

      clearInterval(interval);
    }, INTERVAL_TIME);
  };

  setRebuyImageAriaLabel();

  // Pre-compiled patterns for alt text & link cleanup
  const GENERIC_WORDS = /\b(img|image|photo|picture|banner|icon|logo|graphic|placeholder|untitled|screenshot|pic)\b/gi;
  const FILE_EXT = /\.(jpe?g|png|gif|webp|svg|bmp|tiff?)$/gi;
  const CLEANUP = /^[-–—\s]+|[-–—\s]+$/g;
  const BLANK_LINK_NOTICE = /\bopens in a new tab\b/i;

  const addMissingAlt = () => {
    let count = 0;

    document.querySelectorAll('img:not([alt])').forEach((img) => {
      img.setAttribute('alt', '');
      count++;
    });
  };

  const cleanAltText = () => {
    let count = 0;

    document.querySelectorAll('img[alt]').forEach((img) => {
      const original = img.getAttribute('alt');
      if (!original?.trim()) return;

      const cleaned = original
        .replace(/_/g, ' ')
        .replace(GENERIC_WORDS, '')
        .replace(FILE_EXT, '')
        .replace(/\s+/g, ' ')
        .replace(CLEANUP, '')
        .trim();

      if (cleaned !== original && cleaned) {
        img.setAttribute('alt', cleaned);
        count++;
      }
    });
  };

  const fixBlankLinks = (selectors = document) => {
    const selectorList = Array.isArray(selectors) ? selectors : [selectors];

    selectorList.forEach((selector) => {
      const roots =
        selector && typeof selector === "string"
          ? document.querySelectorAll(selector)
          : [document];

      roots.forEach((root) => {
        if (!root) return;

        root.querySelectorAll('a[target="_blank"]').forEach((link) => {
          if (!link.hasAttribute("rel")) {
            link.setAttribute("rel", "noopener noreferrer");
          }

          const hasHiddenNotice = Array.from(
            link.querySelectorAll(".visually-hidden")
          ).some((span) =>
            /\bopens in a new tab\b/i.test(span.textContent || "")
          );

          if (!hasHiddenNotice) {
            const hiddenSpan = document.createElement("span");
            hiddenSpan.className = "visually-hidden";
            hiddenSpan.textContent = " (opens in a new tab)";
            link.appendChild(hiddenSpan);
          }
        });
      });
    });
  };

  const processAltText = () => {
    addMissingAlt();
    cleanAltText();
    fixBlankLinks([document, "#shopify-pc__banner", ".rte.content-post", ".shopify-policy__body .rte"]);
  };

  let debounce;
  setTimeout(processAltText, 500);

  new MutationObserver((mutations) => {
    const hasImages = mutations.some(m =>
      [...m.addedNodes].some(n => n.nodeType === 1 && (n.tagName === 'IMG' || n.querySelector?.('img')))
    );
    if (hasImages) {
      clearTimeout(debounce);
      debounce = setTimeout(processAltText, 200);
    }
  }).observe(document.body, { childList: true, subtree: true });

  const addIframeTitles = () => {
    const setTitle = (iframe) => {
      if (
        iframe.hasAttribute("data-title-set")
      ) return;

      if (!iframe.hasAttribute("title") || !iframe.getAttribute("title").trim()) {
        const src = iframe.getAttribute("src") || "";
        let titleText = "Embedded Content";

        if (src.includes("surveymonkey.com")) {
          titleText = "SurveyMonkey Donations Form";
        } else if (src.includes("youtube.com") || src.includes("youtu.be")) {
          titleText = "YouTube Video Player";
        } else if (src.includes("vimeo.com")) {
          titleText = "Vimeo Video Player";
        }

        iframe.setAttribute("title", titleText);
      }

      iframe.setAttribute("data-title-set", "true");
    };

    document.querySelectorAll("iframe").forEach(setTitle);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;

          if (node.tagName === "IFRAME") {
            setTitle(node);
          }

          node.querySelectorAll?.("iframe").forEach(setTitle);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  addIframeTitles();

  function observeLinksAria(targetTexts = ['here']) {
    const targetSet = new Set(targetTexts.map(t => t.toLowerCase()));

    const accordionContents = document.querySelectorAll('.product__accordion .accordion__content');
    if (accordionContents.length === 0) return;

    const findNearestStrong = (link) => {
      let el = link;
      while (el) {
        let sibling = el.previousElementSibling;
        while (sibling) {
          if (sibling.tagName.toLowerCase() === 'strong') return sibling;
          const strongInside = sibling.querySelector('strong');
          if (strongInside) return strongInside;
          sibling = sibling.previousElementSibling;
        }

        el = el.parentElement;
      }
      return null;
    };

    const updateLinks = (container) => {
      const links = container.querySelectorAll('a');
      links.forEach(link => {
        const linkTextLower = link.textContent.trim().toLowerCase();
        if (targetSet.has(linkTextLower)) {
          const strong = findNearestStrong(link);
          if (strong) {
            const originalText = link.textContent.trim();
            const strongText = strong.textContent.trim();
            const tabText = link.target === '_blank' ? ' (opens in a new tab)' : '';
            link.setAttribute('aria-label', `${originalText} — ${strongText}${tabText}`);
          }
        }
      });
    };

    accordionContents.forEach(container => updateLinks(container));

    accordionContents.forEach(container => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) {
              if (node.matches && node.matches('a')) {
                updateLinks(container);
              } else if (node.querySelectorAll) {
                updateLinks(container);
              }
            }
          });
        });
      });
      observer.observe(container, { childList: true, subtree: true });
    });
  }

  observeLinksAria();

  (function () {
    const cartId = 'rebuy-cart';
    const bubbleSelector = '.c-cart-title--bubble > span[aria-hidden="true"]';

    const removeAriaHidden = () => {
      const cart = document.getElementById(cartId);
      if (!cart || !cart.classList.contains('is-visible')) return false;

      const span = cart.querySelector(bubbleSelector);
      if (span && span.hasAttribute('aria-hidden')) {
        span.removeAttribute('aria-hidden');
        return true;
      }
      return false;
    };

    const observer = new MutationObserver(() => {
      if (removeAriaHidden()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    removeAriaHidden();
  })();

  (function () {
    const state = {
      cookieBanner: null,
      prefsModal: null,
      klaviyoModal: null,
      cookieTrap: null,
      trapPaused: false,
      lastFocusedBeforePrefs: null
    };

    function getFocusable(container) {
      return [...container.querySelectorAll(`
        a[href],
        button:not([disabled]),
        textarea,
        input:not([type="hidden"]),
        select,
        [tabindex]:not([tabindex="-1"])
      `)];
    }

    function focusContainer(el) {
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
      el.focus();
    }

    function createFocusTrap(container) {
      function handleKeydown(e) {
        if (e.key !== 'Tab') return;

        const focusables = getFocusable(container);
        if (!focusables.length) return;

        const first = focusables[0];
        const last = focusables[focusables.length - 1];

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      container.addEventListener('keydown', handleKeydown);

      return {
        destroy() {
          container.removeEventListener('keydown', handleKeydown);
        }
      };
    }

    function handleCookieBanner(banner) {
      state.cookieBanner = banner;
      banner.setAttribute('aria-modal', 'true');

      if (!state.cookieTrap) state.cookieTrap = createFocusTrap(banner);

      const accept = document.getElementById('shopify-pc__banner__btn-accept');
      const decline = document.getElementById('shopify-pc__banner__btn-decline');
      const manage = document.getElementById('shopify-pc__banner__btn-manage-prefs');

      function closeBanner() {
        banner.setAttribute('aria-modal', 'false');
        if (state.cookieTrap) state.cookieTrap.destroy();
        moveToKlaviyoIfExists();
      }

      accept?.addEventListener('click', closeBanner);
      decline?.addEventListener('click', closeBanner);

      manage?.addEventListener('click', () => {
        state.lastFocusedBeforePrefs = manage;
        state.trapPaused = true;
      });
    }

    function handlePrefsModal(modal) {
      state.prefsModal = modal;

      const closeBtn = document.getElementById('shopify-pc__prefs__header-close');
      const acceptAll = document.getElementById('shopify-pc__prefs__header-accept');
      const declineAll = document.getElementById('shopify-pc__prefs__header-decline');
      const saveBtn = document.getElementById('shopify-pc__prefs__header-save');

      function handlePrefsClose() {

        if (state.cookieBanner && state.cookieBanner.style.display !== 'none') {
          if (state.trapPaused && state.cookieTrap) {
            state.trapPaused = false;
          }
        }

        if (state.lastFocusedBeforePrefs) {
          state.lastFocusedBeforePrefs.focus();
          state.lastFocusedBeforePrefs = null;
        }
      }

      function handlePrefsSubmit() {
        if (state.cookieBanner) state.cookieBanner.setAttribute('aria-modal', 'false');
        if (state.cookieTrap) state.cookieTrap.destroy();
        state.trapPaused = false;
        moveToKlaviyoIfExists();
      }

      closeBtn?.addEventListener('click', handlePrefsClose);
      acceptAll?.addEventListener('click', handlePrefsSubmit);
      declineAll?.addEventListener('click', handlePrefsSubmit);
      saveBtn?.addEventListener('click', handlePrefsSubmit);
    }

    function handleKlaviyoModal(modal) {
      state.klaviyoModal = modal;

      const checkVisible = setInterval(() => {
        if (modal.style.display !== 'none') {
          clearInterval(checkVisible);

          if (!state.cookieBanner || state.cookieBanner.style.display === 'none') {
            focusContainer(modal);
          }
        }
      }, 100);
    }

    function moveToKlaviyoIfExists() {
      if (state.klaviyoModal && state.klaviyoModal.style.display !== 'none') {
        focusContainer(state.klaviyoModal);
      }
    }

    const observer = new MutationObserver(() => {
      const banner = document.getElementById('shopify-pc__banner');
      const prefs = document.getElementById('shopify-pc__prefs__dialog');
      const klaviyo = document.querySelector('.needsclick[role="dialog"][aria-label="POPUP Form"]');

      if (banner && !state.cookieBanner) handleCookieBanner(banner);
      if (prefs && !state.prefsModal) handlePrefsModal(prefs);
      if (klaviyo && !state.klaviyoModal) handleKlaviyoModal(klaviyo);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  })();
});
